import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SessionService } from './app/services/session.service';
import { AuthGuard } from './app/auth.guard';
import { AppStateService } from './app/services/app-state.service';
import { InMemoryStorageService } from './app/services/in-memory-storage.service';
import { LoaderComponent } from './app/loader/loader.component';
import { NetworkStatusComponent } from '../src/app/network-status/network-status.component';
import { VersionUpdateBannerComponent } from './app/version-update/version-update-banner.component';
import { VersionUpdateService } from './app/services/version-update.service';
import { LayoutService } from './app/layout/service/layout.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoaderComponent, NetworkStatusComponent, VersionUpdateBannerComponent],
    template: `<app-version-update-banner></app-version-update-banner><app-network-status></app-network-status><app-loader></app-loader><router-outlet></router-outlet>`
})
export class AppComponent implements OnInit, OnDestroy {
    constructor(
        private sessionService: SessionService,
        private auth: AuthGuard,
        private router: Router,
        private appState: AppStateService,
        private inMemoryStorageService: InMemoryStorageService,
        private versionUpdateService: VersionUpdateService,
        private layoutService: LayoutService
    ) {}

    ngOnInit() {
        this.layoutService.loadThemeFromStorage();

        this.appState.isAppBootstrapped = true;
        const refreshIntent = sessionStorage.getItem('refreshIntent');
        console.log('AppComponent initialized');

        this.versionUpdateService.startMonitoring();

        let username = localStorage.getItem('userName');
        const token = localStorage.getItem('accessToken');
        if (token && username) {
            username = username.replace(/^"(.*)"$/, '$1');

            this.sessionService.startHeartbeat(username);
        }
        if (refreshIntent === 'true') {
            sessionStorage.removeItem('refreshIntent');
            console.log('Confirmed: Page was refreshed');

            const userProfileStr = this.inMemoryStorageService.get('userProfile');
            const username = userProfileStr ? JSON.parse(userProfileStr).userName || '' : '';
            console.log(username, 'username from userProfile');

            if (username) {
                this.sessionService.startHeartbeat(username);
            }
        }
    }

    ngOnDestroy(): void {}

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: BeforeUnloadEvent) {
        const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
        const navType = navEntry?.type;
        const skipReloadPrompt = sessionStorage.getItem(this.versionUpdateService.skipReloadPromptKey) === 'true';
        if (this.router.url.startsWith('/login') || this.router.url === '/login') {
            this.auth.logout();
        }
        if (navType === 'reload') {
            sessionStorage.setItem('refreshIntent', 'true');
            if (skipReloadPrompt) {
                sessionStorage.removeItem(this.versionUpdateService.skipReloadPromptKey);
                return;
            }
            setTimeout(() => {
                sessionStorage.removeItem('refreshIntent');
            }, 5000);

            event.preventDefault();
            event.returnValue = '';
        }
    }
}
